import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import useWindowDimensions from '../../../core/hooks/useWindowDimensions'

import styles from './SearchLine.module.scss'

type TypeItemsProps = 'city' | 'metro' | 'cats' | 'date' | 'square' | 'rating' | 'stocks'

interface ItemProps {
	type: TypeItemsProps
	value: string
	onChange: (value: any) => void
	onClick: () => void
	onBlur: () => void
	onFocus: () => void
	disabled?: boolean
	dateOnClick?: () => void
}

const Item: FC<ItemProps> = ({ type, value, onChange, onClick, onBlur, onFocus, disabled = false, dateOnClick }) => {
	const { formatMessage: f } = useIntl()
	const { width } = useWindowDimensions()

	return (
		<>
			<div
				className={styles.search_input + (disabled ? ' ' + styles.disabled : '')}
				onClick={() => (width > 768 ? false : onClick)}
			>
				{width > 768 ? (
					type == 'date' ? (
						<input
							id={`sl_${type}`}
							name={`sl_${type}`}
							type='text'
							placeholder='__ /__ /____'
							value={value}
							onClick={dateOnClick}
						/>
					) : (
						<input
							id={`sl_${type}`}
							name={`sl_${type}`}
							type='text'
							placeholder={f({ id: 'studios_srch_' + type })}
							value={value}
							onChange={onChange}
							onBlur={onBlur}
							onFocus={onFocus}
							disabled={disabled}
						/>
					)
				) : (
					<span style={{ color: value == '' ? 'rgba(0, 0, 0, 0.3)' : '#000' }}>
						{value == '' ? f({ id: 'studios_srch_all' }) : value}
					</span>
				)}
			</div>
		</>
	)
}

export default observer(Item)
